import { useParams } from 'react-router-dom';
import { InvitationContainer, StatusContent } from './components';
import { useInvitationRouter } from './use-invitation-router';

/**
 * Smart invitation router that detects device type and routes appropriately
 * - Mobile devices: Attempts to open mobile app token-entry page via deep link, falls back to web
 * - Desktop/Web: Routes directly to web flow with pairing code
 */
export default function InvitationRouter() {
  const { pairingCode } = useParams<{ pairingCode: string }>();

  const { status, countdown, handleContinueInBrowser } = useInvitationRouter({
    pairingCode,
  });

  return (
    <InvitationContainer>
      <StatusContent
        status={status}
        countdown={countdown}
        onContinueInBrowser={handleContinueInBrowser}
      />
    </InvitationContainer>
  );
}
